import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import UserAccessDashboard from "pages/user-access-dashboard";
import RoleProfileManagement from "pages/role-profile-management";
import PermissionMatrixManagement from "pages/permission-matrix-management";
import ComplianceAuditCenter from "pages/compliance-audit-center";
import AccessRequestWorkflow from "pages/access-request-workflow";
import SystemIntegrationMonitor from "pages/system-integration-monitor";
import NotFound from "pages/NotFound";
import TravelManagementDashboard from "pages/travel-management-dashboard";
import VAHiringManagement from "pages/va-hiring-management";
import TravelPartnersIntegration from "pages/travel-partners-integration";
import PublicRegistrationPortal from "pages/public-registration-portal";
import PartnerApplicationSubmission from "pages/partner-application-submission";
import PartnerPortalDashboard from "pages/partner-portal-dashboard";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<UserAccessDashboard />} />
        <Route path="/user-access-dashboard" element={<UserAccessDashboard />} />
        <Route path="/role-profile-management" element={<RoleProfileManagement />} />
        <Route path="/permission-matrix-management" element={<PermissionMatrixManagement />} />
        <Route path="/compliance-audit-center" element={<ComplianceAuditCenter />} />
        <Route path="/access-request-workflow" element={<AccessRequestWorkflow />} />
        <Route path="/system-integration-monitor" element={<SystemIntegrationMonitor />} />
        <Route path="/travel-management-dashboard" element={<TravelManagementDashboard />} />
        <Route path="/va-hiring-management" element={<VAHiringManagement />} />
        <Route path="/travel-partners-integration" element={<TravelPartnersIntegration />} />
        <Route path="/public-registration-portal" element={<PublicRegistrationPortal />} />
        <Route path="/partner-application-submission" element={<PartnerApplicationSubmission />} />
        <Route path="/partner-portal-dashboard" element={<PartnerPortalDashboard />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;